import { Control, FieldErrors } from 'react-hook-form';
import { makeStyles, tokens } from '@fluentui/react-components';

import { ControlledField } from '@shared/components';

import { TRequestFormData } from '../../validation';
import { formatDate } from '../../utils';
import { DefinitionList, SectionCard } from '../shared';

const useStyles = makeStyles({
  fields: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalL, maxWidth: '720px' },
  readonlyRow: { marginBottom: tokens.spacingVerticalM },
});

type TProps = {
  control: Control<TRequestFormData>;
  errors: FieldErrors<TRequestFormData>;
  readOnly: boolean;
  initiator: string;
  requestDate: string;
};

export const RequestDetailsSection = ({ control, errors, readOnly, initiator, requestDate }: TProps) => {
  const classes = useStyles();
  return (
    <SectionCard
      title="Request details"
      description="Explain the proposed change. A professional assessment happens later."
    >
      <div className={classes.readonlyRow}>
        <DefinitionList
          items={[
            { label: 'Initiator', value: initiator },
            { label: 'Request date', value: formatDate(requestDate) },
          ]}
        />
      </div>
      <div className={classes.fields}>
        <ControlledField
          name="title"
          control={control}
          errors={errors}
          label="Title"
          readonly={readOnly}
          placeholder="Short descriptive title"
        />
        <ControlledField
          name="description"
          control={control}
          errors={errors}
          inputType="textarea"
          label="Description"
          readonly={readOnly}
          resize="vertical"
          placeholder="What is being changed?"
        />
        <ControlledField
          name="reasonOrTrigger"
          control={control}
          errors={errors}
          inputType="textarea"
          label="Reason or trigger"
          readonly={readOnly}
          resize="vertical"
          placeholder="Why is this change needed?"
        />
        <ControlledField
          name="desiredOutcome"
          control={control}
          errors={errors}
          inputType="textarea"
          label="Desired outcome"
          readonly={readOnly}
          resize="vertical"
          placeholder="What should be true once the change is done? (optional)"
        />
        <ControlledField
          name="implementationProposal"
          control={control}
          errors={errors}
          inputType="textarea"
          label="Implementation proposal"
          readonly={readOnly}
          resize="vertical"
          placeholder="An optional early idea for how to implement it."
        />
      </div>
    </SectionCard>
  );
};
